<span [ngSwitch]="evaluationType">
  <span *ngSwitchCase="evaluationTypeEnum.Laboratory_Testing">
    {{'forms.laboratoryTests' | translate}}
  </span>
  <span *ngSwitchCase="evaluationTypeEnum.Technical_Evaluation">
    {{'forms.technicalEvaluation' | translate}}
  </span>
</span>